import React, { useEffect, useState, createElement } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton, PageHero, SectionLabel } from '../components/shared';
import { industries } from '../data/site';
export function Industries() {
  const [active, setActive] = useState(industries[0]);
  const {
    hash
  } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const slug = hash.replace('#', '');
    const found = industries.find(i => i.slug === slug);
    if (found) {
      setActive(found);
      setTimeout(() => {
        document.getElementById('industry-detail')?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    }
  }, [hash]);
  return <>
      <PageHero eyebrow="Industry ready" title="Security designed around how your property actually works." subtitle="Each industry has its own rhythms, risks, and routines. Pick yours to see how Watchdog approaches it." data-id="element-417">
        <CTAButton to="/assessment" data-id="element-418">Free assessment</CTAButton>
      </PageHero>

      <section id="industry-detail" className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-id="element-419">
        <div className="grid gap-8 lg:grid-cols-[.42fr_.58fr]" data-id="element-420">
          <div className="grid grid-cols-2 gap-3 lg:grid-cols-1" data-id="element-421">
            {industries.map(item => {
            const Icon = item.icon;
            const isActive = item.slug === active.slug;
            return <button key={item.slug} onClick={() => setActive(item)} className={`flex flex-col items-start gap-3 rounded-2xl border p-4 text-left transition lg:flex-row lg:items-center lg:gap-4 lg:rounded-3xl lg:p-5 ${isActive ? 'border-sky-300 bg-sky-50 shadow-xl shadow-sky-100' : 'border-slate-200 bg-white hover:bg-slate-50'}`} data-id="element-422">
                  <div className={`flex h-10 w-10 items-center justify-center rounded-xl lg:h-12 lg:w-12 lg:rounded-2xl ${isActive ? 'bg-sky-400 text-slate-950' : 'bg-slate-100 text-slate-600'}`} data-id="element-423">
                    <Icon className="h-5 w-5 lg:h-6 lg:w-6" data-id="element-424" />
                  </div>
                  <span className="text-sm font-black lg:text-base" data-id="element-425">
                    {item.label}
                  </span>
                </button>;
          })}
          </div>

          <motion.div key={active.slug} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} className="rounded-[2rem] bg-slate-950 p-8 text-white shadow-2xl" data-id="element-426">
            <div className="mb-8 flex h-16 w-16 items-center justify-center rounded-3xl bg-sky-400 text-slate-950" data-id="element-427">
              {createElement(active.icon, {
              className: 'h-8 w-8'
            })}
            </div>
            <h3 className="text-3xl font-black tracking-tight" data-id="element-428">
              {active.label}
            </h3>
            <p className="mt-4 text-xl leading-8 text-slate-300" data-id="element-429">
              {active.headline}
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-430">
              {active.points.map(point => <div key={point} className="flex gap-3 rounded-2xl border border-white/10 bg-white/[0.06] p-4" data-id="element-431">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 flex-none text-sky-300" data-id="element-432" />
                  <span className="text-sm font-bold text-slate-200" data-id="element-433">
                    {point}
                  </span>
                </div>)}
            </div>
            <div className="mt-8 flex flex-wrap gap-3" data-id="element-434">
              <CTAButton to="/assessment" data-id="element-435">
                Free {active.label.toLowerCase()} assessment
              </CTAButton>
              <CTAButton variant="secondary" href="tel:+19168424729" data-id="element-436">
                Call (916) 842-4729
              </CTAButton>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}